// We importeren React en de useState-hook om lokale state te gebruiken in deze component
import React, { useState } from "react";
// We importeren de CSS-styling voor deze pagina
import "./styles/auth.css";

// Dit is de Login-component. Ze krijgt twee functies binnen via props:
// - onLogin → om de gebruiker in te loggen in App.jsx
// - onSwitchToRegister → om te wisselen naar de registreren-pagina
export default function Login({ onLogin, onSwitchToRegister }) {
  // Hier worden drie stukjes "state" aangemaakt om gegevens bij te houden:
  const [gebruiksnaam, setGebruiksnaam] = useState(""); // bewaart wat de gebruiker typt bij de gebruikersnaam
  const [wachtwoord, setWachtwoord] = useState(""); // bewaart wat de gebruiker typt bij het wachtwoord
  const [error, setError] = useState(""); // toont eventuele foutmeldingen (zoals verkeerde login)

  // Deze functie wordt uitgevoerd zodra de gebruiker op de inlogknop klikt
  const handleLogin = async (e) => {
    e.preventDefault(); // voorkomt dat de pagina herlaadt bij het verzenden van het formulier

    try {
      // We sturen een POST-aanvraag naar de backend (PHP) met de ingevoerde login-gegevens
      const res = await fetch("http://localhost/backend/api/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" }, // we geven aan dat we JSON versturen
        body: JSON.stringify({ gebruiksnaam, wachtwoord }), // hier sturen we de ingevulde data mee
      });

      // We wachten op het antwoord van de server en zetten het om naar JSON
      const data = await res.json();

      // Als de server zegt "success", loggen we de gebruiker in
      if (data.status === "success") {
        // We geven de gebruiker door aan App.jsx, zodat hij naar het dashboard gaat
        onLogin(data.gebruiker);
      } else {
        // Anders tonen we een foutmelding
        setError(data.message || "Ongeldige login");
      }
    } catch (err) {
      // Als er een probleem is met de server of verbinding, tonen we een algemene foutmelding
      setError("Serverfout: " + err.message);
    }
  };

  // De "return" hieronder bepaalt wat er op het scherm wordt getoond (de UI)
  return (
    <div className="auth-page">
      {/* Het formulier dat de gebruiker invult om in te loggen */}
      <form onSubmit={handleLogin} className="auth-card">
        <h2 className="auth-title">Login</h2>

        {/* Gebruikersnaamveld */}
        <div className="auth-row">
          <label className="auth-label">Gebruikersnaam</label>
          <input
            type="text"
            value={gebruiksnaam} // koppelt de waarde aan onze state
            onChange={(e) => setGebruiksnaam(e.target.value)} // elke keer dat je typt, wordt de state bijgewerkt
            className="auth-input"
            required // dit veld moet worden ingevuld
          />
        </div>

        {/* Wachtwoordveld */}
        <div className="auth-row">
          <label className="auth-label">Wachtwoord</label>
          <input
            type="password"
            value={wachtwoord}
            onChange={(e) => setWachtwoord(e.target.value)}
            className="auth-input"
            required
          />
        </div>

        {/* Inlogknop */}
        <div className="auth-actions">
          <button type="submit" className="auth-btn auth-btn--primary">
            Inloggen
          </button>
        </div>

        {/* Foutmelding als de login mislukt */}
        {error && <div className="auth-message auth-message--error">{error}</div>}

        {/* Link om naar de registratiepagina te gaan */}
        <div className="auth-toggle">
          Nog geen account?{" "}
          <button type="button" onClick={onSwitchToRegister}>
            Meld je aan
          </button>
        </div>
      </form>
    </div>
  );
}
